// @ts-nocheck

import React, { useCallback } from 'react';
import QrReader from 'react-qr-reader';
import styled from 'styled-components';

import { getQuerystringParam } from '../../utils';
import { isQRCodeValid } from '../../utils/qr';

const Wrapper = styled.div``;

const StyledQrReader = styled(QrReader)`
  width: 100%;
`;

type QRScannerProps = {
  setQRScanResult: (scan: string) => void;
  onScanSuccess: () => void;
  resetQRScanResult: () => void;
  onWrongQRCode: () => void;
  className?: string;
};

const QRScanner = ({
  setQRScanResult,
  onScanSuccess,
  resetQRScanResult,
  onWrongQRCode,
  className = '',
}: QRScannerProps) => {
  const handleScan = useCallback(
    (scanResult) => {
      const handleError = () => {
        resetQRScanResult();
        onWrongQRCode();
      };

      if (scanResult) {
        const id = getQuerystringParam('id', scanResult);

        if (isQRCodeValid(id, { nullable: false })) {
          resetQRScanResult();
          setQRScanResult(id);
          onScanSuccess();
          return;
        }

        handleError();
      }
    },
    [onWrongQRCode, resetQRScanResult, setQRScanResult, onScanSuccess],
  );

  const handleError = useCallback((err) => {
    console.error(err);
  }, []);

  return (
    <Wrapper className={className}>
      <StyledQrReader delay={300} onError={handleError} onScan={handleScan} />
    </Wrapper>
  );
};

export default QRScanner;
